export const TOKEN_KEY = "cleword_token"

export const VISITOR_ID_KEY = "visitor_id"
